<!-- 项目文件 -->
<template>
    <div>
        <Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg">
        </Header>
        <div class="w100p">
            <div class="w1200 mauto mt50 mb50 bgfff overflow">
                <div class=" w70p disinblock floatl ">
                    <div class="bgf6 baee pl30 pr30 pt10 pb20"> 
                        <div class="overflow">
                            <span class="fs14 c333 disblock floatl w12p pt15">区域筛选 : </span>
                            <div class="floatr disblock w88p">
                                <ul class="overflow">
                                    <li @click="areachoose1()" :class="activeClass == -1 ? 'active11':''" class="cursor  fs14 floatl disinblock ml10 mr10 pt15"> 默认 </li>
                                    <li :class="activeClass == index ? 'active11':''" @click="areachoose(item.id,index)" v-for="(item,index) in district" :key="index" class="cursor c666 fs14 floatl disinblock ml10 mr10 pt15"> {{item.name}} </li>
                                </ul>
                            </div>
                        </div>
                    
                        <div class="overflow mt15">
                            <span class="fs14 c333 disblock floatl w12p ">排序方式 : </span>
                            <div class="floatr disblock w88p">
                                <ul class="overflow">
									<li @click="moren(1,1)" :class="activeClass22 == 1? 'active11':''" class="cursor  fs14 floatl alit ml10 mr10 ">
									    默认
									</li>
									<li  @click="order1(3,4)" :class="activeClass22 == 4 ? 'active11':''" class="cursor c666 fs14 floatl alit ml10 mr10 ">
									    口碑
									    <img class="w3 h12 pl3" src="../../public/img/img81.png">
									</li>
                                    <!-- <li @click="moren(2,1)" :class="activeClass22 == 1? 'active11':''" class="cursor  fs14 floatl alit ml10 mr10 ">
                                        默认
                                    </li> -->
                                    <!-- <li  @click="order1(1,2)" :class="activeClass22 == 2 ? 'active11':''" class="cursor  fs14 floatl alit ml10 mr10">
                                        附近
                                        <img class="w3 h12 pl3" src="../../public/img/img81.png">
                                    </li>
                                    <li  @click="order1(2,3)" :class="activeClass22 == 3 ? 'active11':''" class="cursor c666 fs14 floatl alit ml10 mr10 ">
                                        品牌
                                        <img class="w3 h12 pl3" src="../../public/img/img81.png">
                                    </li> -->
                                    <!-- <li  @click="order1(3,4)" :class="activeClass22 == 4 ? 'active11':''" class="cursor c666 fs14 floatl alit ml10 mr10 ">
                                        口碑
                                        <img class="w3 h12 pl3" src="../../public/img/img81.png">
                                    </li> -->
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class=" pt15">
                        <p class="fs14 c333" v-if="Length==-1">共有 {{schoolList.length}} 所驾校</p>
                        <p class="fs14 c333" v-else>共有 {{Length}} 所驾校</p>
                        <div v-if="schoolShow==1 || schoolShow==item.areaid_3" v-for="(item,index) in schoolList" :key="index" class="border2 overflow pb15 posre mt15 mb15">
                            <div class="floatl disflex" >
                                <span class="disinblock cursor" @click="toSchooldetail(item.school_id)">
                                    <img class="w250 h180 " :src="item.image ||   'https://365taoke.oss-cn-hangzhou.aliyuncs.com/card/20200429/img1.png' ">
                                </span>
                                <div class="ml15">
                                    <p class="fs20 c333 alit fb600 pt5 pb5">
                                         {{item.school_name}} 
                                        <span class="pl10 disinblock">
                                            <img class="w16 h16 mr5" :src="v.medal_img" alt="" v-for="(v,i) in item.medals" :key="i">
                                        </span>
                                    </p>
                                    <p class="fs14 c999 pt5 pb5"> {{item.school_address}} </p>
                                    <p class="fs14 c333 pt5 pb5"> {{cityName}} 驾校 > <span class="c999"> {{item.school_name}} </span></p>
                                   
                                    <p class="fs14 c333 pt5 pb5 posre">
                                        <span class="alit" v-if="item.star">
                                            <img v-if="item.star!=0" v-for="(v,i) in parseInt(item.star)" :key="i" class="w16 h16 mr6"
                                                src="../../public/img/img80_1.png" alt="">
                                            <img v-if="parseInt(item.star) != item.star" class="w16 h16 mr6" src="../../public/img/img80_3.png" alt="">
                                            <img v-if="item.star < 4.1" v-for="(vv,ii) in 5-Math.ceil(item.star)" class="w16 h16 mr6"
                                                src="../../public/img/img80_2.png" alt="">
                                            <i class="cff8 fs15">
                                                {{item.star ||'暂无评分'}}
                                            </i>
                                        </span>
                                    </p>
                                    <p class=' pt5 pb5'>
                                        <span  class="fs14 c333 ">共 {{item.comment_count ||'0'}} 条评论</span>
                                        <img v-for="(v,i) in item.hotImages" v-if="item.hotImages" class="w12 h12 ml10" :src="v" alt="">
                                    </p>
                                </div>
                            </div>
                            <div class="disinblock floatr posab h100p right0 top0 textc">
                            
                                    <div class="cff01 fs30 fbold pb20 pl0 pr0">¥ {{item.min_price}} </div>
                                    <div class="cfff fs20 fbold bradius5 pt5 pb8 pl16 pr16 bg1f8 cursor w100" @click="toSchooldetail(item.school_id)">立即报名</div>
                               
                            </div>
                        </div> 

                       <div @click="pageadd()" class="fs18 textc c333 cursor" > {{loadingtype}}... </div>

                    </div>
                </div>
                <Registration :Area_id="Area_idX"></Registration>
            </div>
            
        </div>
        <Footer></Footer> 
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Registration from '@/components/Registration'
    import $ from "jquery";
    export default {
        data() {
            return {
                color: 1,
                link: 2,
                titleList: 4,
                logo: 'home',
                bgImg: require('../../public/img/img51.png'),
                Area_idX: '',
                district: [],
                schoolList: [],
                cityName: '',
                schoolShow: 1,
                page: 1,
                Length: -1,
                type: 2,
                activeClass: -1,
                activeClass22: 1,
                mask: 0,
                Name: '',
                Phone: "",
                count: '',
                show: true,
                Code: '',
                School_id: '',
                loadingtype: '点击加载更多',
                Lng: '',
                Lat: ''
            };
        },
        components: {
            Header,
            Footer,
            Registration
        },
        methods: {
            getDistrict() {
                let that = this;

                that.cityName = that.$store.state.cityName;
                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/school/getAreasByCity.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "city_id": that.Area_idX,
                    },
                    success: function(data) {
                        that.district = data.obj;
                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            getCityP() {
                var that = this;
                var map = new BMap.Map("container");
                var nowCity = new BMap.LocalCity();
                nowCity.get(bdGetPosition);

                function bdGetPosition(result) {

                    that.Lng = result.center.lng
                    that.Lat = result.center.lat
                    that.getSchool()
                }

            },
            getSchool() {
                let that = this;

                if (that.type != 4 && that.page == 1) {
                    that.schoolList = []
                }

                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/school/getSchoolList.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "area_id": that.Area_idX,
                        "sort_type": that.type,
                        "lat": that.Lat,
                        "lng": that.Lng,
                        "page": that.page,
                    },
                    success: function(data) {
                        if (data.obj.length == 0) {
                            that.loadingtype = "没有更多了";
                            return;
                        }
                        for (let i = 0; i < data.obj.length; i++) {
                            that.schoolList.push(data.obj[i]);
                        }

                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },


            pageadd() {
                this.page++;
                this.getSchool();
                this.Length = this.schoolList.length
            },
            order1(id, index) {

                this.page = 1;
                this.type = id;
                this.activeClass22 = index;
                this.getSchool();

                this.Length = this.schoolList.length
            },
            moren(id, index) {
                let that = this;
                this.page = 1;
                this.activeClass22 = index;
                this.type = id;
                this.getSchool();
                if (that.schoolList == '' || that.schoolList == undefined || that.schoolList.length == 0) {
                    that.type = 3
                    that.getSchool();
                    if (that.schoolList == '' || that.schoolList == undefined || that.schoolList.length == 0) {
                        that.type = 1
                        that.getSchool();
                    }
                }
                this.Length = this.schoolList.length
            },
            areachoose(id, index) {
                let that = this;
                this.schoolShow = id;
                this.page = 1
                that.activeClass = index;
                that.Length = 0;
                for (let i = 0; i < that.schoolList.length; i++) {
                    if (id == that.schoolList[i].areaid_3) {
                        that.Length++;
                    }
                }
            },

            areachoose1() {
                this.activeClass = -1;
                this.page = 1
                this.schoolShow = 1;
                this.Length = this.schoolList.length;
                this.getSchool()
            },
            toSchooldetail(id) {
                this.$router.push({
                    path: `/Schooldetail`,
                    query: {
                        schoolId: id,
                        cityid: this.Area_idX
                    }
                })
            }
        },
        created() {
            let that = this;
            that.Area_idX = this.$route.query.cityid;
            this.getDistrict();
            this.getCityP();
            if (that.schoolList == '' || that.schoolList == undefined || that.schoolList.length == 0) {
                that.type = 3
                that.getSchool();
                if (that.schoolList == '' || that.schoolList == undefined || that.schoolList.length == 0) {
                    that.type = 1
                    that.getSchool();
                }
            }
        },
        mounted() {
            if (window.performance.navigation.type == 1) {
                $('body').css("overflow", "auto")
            }

        }
    }
</script>
<style scoped>
    .active11 {
        color: #1f82f6;
    }
    
    .bgrg {
        background: rgba(0, 0, 0, 0.5);
    }
</style>